import Link from 'next/link'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserInsLikes, openCommentModal, openModal, setFilterInfoModalVisible } from '../../redux/communityReducers/PostActionsReducer'
import { logEvent } from '../../utils/firebase'
import { getImageSource } from '../../utils/getImageSource'
import { getUsername } from '../../utils/getUsername'
import DesignCanvas from '../DesignCanvas'
import { AnimatedFilterTag } from '../Feed/AnimatedFilterTag'
import SocialContainer from '../social/SocialContainer'
import UserInfoHeader from './DesignHeader'
import * as styles from './details.module.css'
import { Price } from './Price'
import { Tags } from './Tags'

export const Main = props => {
  const dispatch = useDispatch()
  const { userInsLikeList, userInsCommentList } = useSelector(state => state.postActions)
  const { data, id, active } = props
  const { title } = data
  const userName = getUsername(data.user)
  const [likeCount, setLikeCount] = useState(0)
  const [commentCount, setCommentCount] = useState(0)

  const { likes: likesObj, updatedLikeObj } = useSelector(state => state.like)

  useEffect(() => {
    setCommentCount(props.data.numComments)
  }, [props.data.numComments])
  useEffect(() => {
    if (userInsCommentList?.length) setCommentCount(userInsCommentList?.length)
  }, [userInsCommentList?.length])

  useEffect(() => {
    setLikeCount(userInsLikeList.length)
    if (updatedLikeObj.id === id) setLikeCount(updatedLikeObj.numOfLikes)
  }, [id, userInsLikeList.length, updatedLikeObj])

  useEffect(() => {
    dispatch(getUserInsLikes(id))
  }, [dispatch, id])

  const titleArr = title ? title.split(' ') : title
  let titleDiv = title
    ? titleArr.map(item => {
        if (item.indexOf('#') !== -1) {
          return (
            <Link
              role={'link'}
              href={`/hashtag/${encodeURIComponent(item.substr(1))}`}
              title={item}
              onClick={() => {
                logEvent('search_recentsearches_clicked')
              }}
            >
              <a className={styles.desTitle}>{item}</a>
            </Link>
          )
        } else {
          return `${item} `
        }
      })
    : []

  return (
    <>
      <div className={styles.main}>
        <UserInfoHeader {...props} inspirationType={props.data.type} showCaptionModal={props.showCaptionModal} />
        <div className={styles.productImageContainer} style={{ position: 'relative' }}>
          <div className={styles.mContainer}>
            <div style={{ position: 'relative' }}>
              <DesignCanvas priority={true} data={props.data} displayRichContent={true} />
              {props.data.animationInfo && (
                <AnimatedFilterTag
                  mode="right"
                  onClick={() => {
                    dispatch(
                      setFilterInfoModalVisible({
                        visible: true,
                        post: props.data
                      })
                    )
                  }}
                  post={props.data}
                />
              )}
              {props.data.type !== 'vlog' && <Price {...props} />}
            </div>
            <div className={!title ? styles.nondescription : styles.description}>
              <p className={styles.descriptionBlock}>
                <span className={styles.userName}>{userName}</span>
                {titleDiv}
              </p>
            </div>
            <div className={styles.status}>
              <div className={styles.like} onClick={() => dispatch(openModal({ likeNum: likeCount, id }))}>
                {likeCount} Likes
              </div>
              <div className={styles.comment} onClick={() => dispatch(openCommentModal({ commentCount, data, id }))}>
                {commentCount} Comments
              </div>
            </div>
            <div className={styles.mediaContainer}>
              <SocialContainer loc="detail" id={id} imgUrl={getImageSource(data).src} active={active} numLikes={props.numLikes} numComments={commentCount} data={data} type={data.type} color="opacity" />
            </div>
            <Tags notableObjects={data.notableObjects} />
          </div>
        </div>
      </div>
    </>
  )
}
